document.addEventListener("DOMContentLoaded", function () {
    var SwiperCustomer = new Swiper(".content-slider-customer", {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
  